import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Confirm from '../../components/Change/Confirm';
import { HomeSelector } from '../reducers/HomeReducer';
import { PlansSelector } from '../reducers/PlansReducer';
import { MyAccountSelector } from '../reducers/MyAccountReducer';
import MyAccountAction from '../actions/MyAccountAction';
import { CheckoutSelector } from '../reducers/CheckoutReducer';

const getConnectionDate = (state) => {
  const now = new Date();
  if (state.form.checkout && state.form.checkout.values) {
    const connectionDate = state.form.checkout.values.connectionDate;
    const preferredDate = state.form.checkout.values.preferredDate;
    if (connectionDate && connectionDate === 'preferred' && preferredDate) {
      const dateParts = preferredDate.split('/');
      // month is 0-based, that's why we need dataParts[1] - 1
      return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    }
    return now;
  }
  return now;
};

const mapStateToProps = state => ({
  toAddress: HomeSelector.getSelectedAddressParts(state),
  connectionDate: getConnectionDate(state),
  error: HomeSelector.getError(state),
  customerInfo: MyAccountSelector.getCustomerInfo(state),
  availablePlans: PlansSelector.getAvailablePlans(state),
  selectedPlanId: PlansSelector.getSelectedPlanId(state),
  speedChangeOption: CheckoutSelector.getSpeedChangeOption(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    sendChange: MyAccountAction.sendChange
  }, dispatch);

const ConfirmChangeContainer = connect(mapStateToProps, mapDispatchToProps)(Confirm);

export default ConfirmChangeContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ConfirmChangeContainer.js
 **/